/**
 * @file index.tsx
 *
 * @fileoverview Renders the setup for Google Leaderboard Banner Ad script.
 */
import Script from 'next/script';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import React from 'react';

interface AdnuntiusMpu2BannerAdProps {}
export default function AdnuntiusMpu2BannerAd({}: AdnuntiusMpu2BannerAdProps) {
  return (
    <AlignedCenter>
      <div
        id="adn-4ed42f"
        style={{
          display: 'none',
        }}
      ></div>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.adn = window.adn || {}; adn.calls = adn.calls || []; adn.calls.push(function() { adn.request({ network: '57ff2', adUnits: [ {auId: '4ed42f', auW: 300, auH: 250 } ]}); });
          `,
        }}
      />
    </AlignedCenter>
  );
}
